import { Link } from "react-router-dom";
import { Tooltip, Stack, IconButton, Typography } from "@mui/material";
import { VisibilityOutlined } from "@mui/icons-material";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { StyleSheet, css } from "aphrodite";

import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "../../styles/style.css";
import Colors from "../../constants/Colors";

interface Props {
  visits: any[];
}

const VisitsListingTable = (props: Props) => {
  const { visits } = props;

  let qtde = visits.length;
  const getClientLabel = (visit: any) => {
    const clienteApelido = visit.clienteApelido?.trim();
    const clienteNome = visit.clienteNome?.trim();
    const hasValidNickname =
      !!clienteApelido && clienteApelido.toUpperCase() !== "N/A";

    return (hasValidNickname ? clienteApelido : clienteNome) || "N/A";
  };

  if (visits.length === 0) {
    return (
      <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
        Nenhuma visita encontrada.
      </Typography>
    );
  }

  const getStatusLabel = (situacao: string) => {
    switch (situacao) {
      case "1":
        return "Aberto";
      case "2":
        return "Encerrado";
      default:
        return "Desconhecido";
    }
  };

  const getStatusColor = (situacao: string) => {
    switch (situacao) {
      case "1":
        return "orange";
      case "2":
        return "green";
      default:
        return "grey";
    }
  };

  return (
    <Table className={css(styles.table)}>
      <Thead className="table_head">
        <Tr>
          <Th>Visita ID</Th>
          <Th>Cliente</Th>
          <Th>Check-in</Th>
          <Th>Checkout</Th>
          <Th>Vendedor</Th>
          <Th>Status</Th>
          <Th>Ação</Th>
        </Tr>
      </Thead>
      <Tbody>
        {visits.map((visit) => {
          var parity = qtde % 2;
          qtde = qtde - 1;
          const statusLabel = getStatusLabel(visit.situacao);
          const statusColor = getStatusColor(visit.situacao);

          return (
            <Tr
              key={visit.id}
              className={parity === 1 ? "odd_row" : "even_row"}
            >
              <Td className="table_actions">{visit.id}</Td>
              <Td className="table_text">{getClientLabel(visit)}</Td>
              <Td className="table_actions">
                {visit.dataCheckin || "-"} {visit.horaCheckin || ""}
              </Td>
              <Td className="table_actions">
                {visit.dataCheckout || "-"} {visit.horaCheckout || ""}
              </Td>
              <Td className="table_actions">{visit.nomeVendedor || "N/A"}</Td>
              <Td>
                <Stack
                  direction={"row"}
                  width={"100%"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Tooltip arrow title={statusLabel}>
                    <span>
                      <IconButton
                        disabled
                        sx={{
                          "&:disabled": {
                            backgroundColor: statusColor,
                            width: 12,
                            height: 12,
                            padding: 0,
                          },
                        }}
                      />
                    </span>
                  </Tooltip>
                  <Typography variant="caption" sx={{ ml: 1 }}>
                    {statusLabel}
                  </Typography>
                </Stack>
              </Td>
              <Td className="table_actions">
                <Stack
                  direction={"row"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Tooltip arrow title="Visualizar Detalhes">
                    <Link
                      style={{
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      to={`/visitas/detalhes`}
                      state={{
                        id: visit.id,
                        visitData: visit,
                      }}
                    >
                      <VisibilityOutlined color="action" fontSize="small" />
                    </Link>
                  </Tooltip>
                </Stack>
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

const styles = StyleSheet.create({
  table: {
    fontSize: 13,
    display: "table",
    width: "100%",
  },
});

export default VisitsListingTable;
